import { createAsyncThunk,createSlice } from '@reduxjs/toolkit';
import { MakeAxiosRequest } from '../utils/handler';

const storedUser = localStorage.getItem('user');

// export const updateNotificationCount = () => async (dispatch) => {
//   try {
//     // alert('test')
    
//   } catch (error) {
//     console.error("Error updating notification count:", error);
//   }
// };

const initialState = {
  isAuthenticated: Boolean(storedUser),
  notificationCount: 0,
  user: storedUser ? JSON.parse(storedUser) : null,

//   pendingcount:  {
//     issueCount:0,
//     revewsCount:0,
//     offersCount:0,
//     unReadCount:0
// }
};
export const fetchNotificationCount = createAsyncThunk(
  'notification/fetchCount',
  async () => {
    const response = await MakeAxiosRequest("post", "/notifications");
    
    return response.unreadCount;
  }
);
export const updateProfile = createAsyncThunk(
  'fetchprofile',
  async () => {
    const response = await MakeAxiosRequest("post", "/settings");
    return response.data;
  }
);
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {

    // updateUnreadNotificationCount: (state, action) => {
    //   state.unreadNotificationCount = action.payload.is_unread;
    // },
    

    login: (state, action) => {
      localStorage.setItem('accesstoken', action.payload.accesstoken);
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.isAuthenticated = true;
      state.user = action.payload;
    },

    updateNotificationCount: (state, action) => {
      state.user.hasnotification = action.payload;
    },

    update: (state, action) => {
      const first_name = action.payload.first_name;
      const last_name = action.payload.last_name;
      const profileimg = action.payload.profile_image;

      const localData = localStorage.getItem('user');
      let parsedData = {};
      if (localData) {
        parsedData = JSON.parse(localData);
      }
      parsedData.first_name = first_name;
      parsedData.last_name = last_name;
      parsedData.profileimg = profileimg; // Update the image
      const updatedData = JSON.stringify(parsedData);
      localStorage.setItem('user', updatedData);

      // console.log(state);
      // console.log(action.payload);
      state.user.first_name = first_name;
      state.user.last_name = last_name;
      state.user.profileimg = profileimg;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem('accesstoken');
      localStorage.removeItem('user');
      console.log("logout");
    },
    // updateCount: (state, action) => {  
    //   state.pendingcount.issueCount = action.payload.issueCount;
    //   state.pendingcount.revewsCount = action.payload.revewsCount;    
    //   state.pendingcount.offersCount = action.payload.offersCount;    
    //   state.pendingcount.unReadCount = action.payload.unReadCount;
    // },

    // // updateNotificationCount: (state) => {    
    // //   const res = MakeAxiosRequest("post", `/notifications/unreadcount`); 
    // //   console.log(res,'updateNotificationCount');    
    // //   state.pendingcount.unReadCount = res.is_unread;
    // // },
    clearNotificationCount: (state) => {     
    //   state.pendingcount.unReadCount = 0;
    },

  },
  extraReducers: (builder) => {

    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.user.userDetails = {
        ...state.user.userDetails, // Spread existing details to keep other fields
        ...action.payload.usersDetails, // Update with new user details
        org_image: action.payload.organizationData.image_path, // Update organization image
        organization_name: action.payload.organizationData.company_name, // Update organization name
      };
      const first_name = action.payload.usersDetails.first_name;
      const last_name = action.payload.usersDetails.last_name;
      const profileimg = action.payload.usersDetails.profile_image;
      const orgImg = action.payload.organizationData.image_path;
      const organization_name = action.payload.organizationData.company_name;
      const localData = localStorage.getItem('user');
      let parsedData = {};
      if (localData) {
        parsedData = JSON.parse(localData);
      }
      parsedData.userDetails.first_name = first_name;
      parsedData.userDetails.last_name = last_name; 
      parsedData.userDetails.profile_image = profileimg; // Update the image
      parsedData.userDetails.org_image = orgImg;
      parsedData.userDetails.organization_name = organization_name;
      const updatedData = JSON.stringify(parsedData);
      localStorage.setItem('user', updatedData);

      state.user.first_name = first_name;
      state.user.last_name = last_name;
      state.user.profileimg = profileimg;
      state.user.org_image = orgImg;
    });

    builder.addCase(fetchNotificationCount.fulfilled, (state, action) => {

      state.notificationCount = action.payload;
    });

    // builder.addCase(fetchWalletAmount.fulfilled, (state, action) => {
    //   // console.log(action.payload);
    //   state.walletAmount = action.payload;
    // });
    
  },
});

export const { login, logout, clearNotificationCount, updateWalletAmount,updateNotificationCount,update } = authSlice.actions;
export default authSlice.reducer;